import { render, staticRenderFns } from "./others.vue?vue&type=template&id=1c42d8c6"
import script from "./others.vue?vue&type=script&lang=js"
export * from "./others.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports